module.exports = __webpack_public_path__ + "static/media/PhoneNumber.4d9d5e41.png";